import React, { Component } from 'react'
import theme, { whiteLabelData } from '../../theme'
import log from 'loglevel'

import PropTypes from 'prop-types'

import { Link } from 'react-router-dom';
import i18next, {t} from 'i18next';
import {Trans} from 'react-i18next'

// Application Components
import Aux from '../../hoc/Ax/Ax'
import toast from "../../../utils/ToasterService";



import { Paper, Grid, TextField, Button, Typography, Select, Container } from '@mui/material'


const styles = {
    root: {
        padding: theme.spacing(4),
        maxWidth: 420,
        boxSizing: 'border-box',
        width: '100%',
    },
    sendButton: {
        width: 'auto',
    },
    buttonContainer: {
      marginTop: 20,
    },
    error: {
        color: theme.palette.error.main,
        display: 'flex',
        alignItems: 'flex-end',
        fontSize: 12,
    },
    textForm: {
        [theme.breakpoints.up('xs')]: {
            width: 229,
        },
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
    },
    textField: {
        minWidth: 'inherit',
    },
    successText: {
        lineHeight: 2,
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    selectLang: {
      fontSize: 12,
    }
}

/**
 * component for sidebar
 * @param error
 * @param success
 * @param classes
 * @returns {*}
 */
class PasswordReset extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            error: this.props.error,
            success: this.props.success,
            requestPending: this.props.requestPending,
            regexEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
            language: i18next.language
        }
    }

    static defaultProps = {
        error: false,
        success: false,
        requestPending: false,
    }

    static propTypes = {
        error: PropTypes.bool,
        success: PropTypes.bool,
        requestPending: PropTypes.bool,
        classes: PropTypes.objectOf(PropTypes.string).isRequired,
        onRequestResetMail: PropTypes.func.isRequired
    }

    resetPassword = () => {
      const { email } = this.state;

      this.setState({ requestPending: true });

      if(this.inputsValid()) {
        this.props.onRequestResetMail(email,
            () => {
                toast.success(t('PasswordReset.toast_success'));
                this.setState({ success: true });
                this.setState({ requestPending: false });
            },
            (error) => {
                log.error('Request failed --> ', error);
                toast.error(error.msg);
                this.setState({ requestPending: false });
            })
      } else {
        toast.error(t('PasswordReset.toast_error'));
      }
    };

    inputsValid = () => {
        const { email, regexEmail } = this.state;
        let result = true;

        if (regexEmail.test(email.toLowerCase())) {
          this.setState({error: false})
        } else {
          this.setState({error: true})
          result = false;
        }

        return result;
    };

    emailValid = () => {
      const { email, regexEmail } = this.state;

      return email.trim().length > 0 ? regexEmail.test(email.toLowerCase()) : true ;
    };

    checkEnterSubmit = (ev) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            this.resetPassword();
        }
    };

    backToLogin = () => {
        this.props.router.push('/login')
    };

    handleLanguageChange = (event) => {
      i18next.changeLanguage(event.target.value)
      this.setState({language: event.target.value})
    }

    render() {
        const { classes } = this.props
        const { error, success, email, requestPending } = this.state;

        return (
            <Container  component="main" maxWidth="md">
                <Grid container justifyContent="center">
                    <Grid item style={{ marginBottom: 50, marginTop:50 }}>
                        <img style={{ width: '100%', maxWidth: '300px' }} src={whiteLabelData.logo} alt="" />
                    </Grid>
                </Grid>
                <Grid container justifyContent="center">
                    <Paper sx={{padding: 5, width: '100%', maxWidth: 420}}>
                        <Grid container direction="column" justifyContent="center" alignItems="center">
                            <Typography style={{ fontSize: 20 }}>
                              {whiteLabelData.name}
                            </Typography>
                            <Typography style={{ fontSize: 16 }}>
                              <Trans i18nKey="PasswordReset.title"/>
                            </Typography>
                            {!success && (
                                <Grid container direction="column" justifyContent="center" alignItems="center">
                                    <TextField
                                        InputProps={{
                                            classes: {
                                                underline: styles.textFieldUnerline
                                            },
                                        }}
                                        InputLabelProps={{
                                            FormLabelClasses: {
                                                root: styles.textFieldFormLabel,
                                                focused: styles.textFieldFocused,
                                            },
                                        }}
                                        error={error}
                                        label={t('Global.title_email')}
                                        margin="normal"
                                        value={email}
                                        style={styles.textField}
                                        fullWidth={true}
                                        onChange={e => this.setState({ email: e.target.value })}
                                        onKeyPress={(ev) => this.checkEnterSubmit(ev)}
                                        // helperText={error ?  t('PasswordReset.textfield_email_helpertext_error') : t('PasswordReset.textfield_email_helpertext')}
                                        helperText={!this.emailValid() ? t('PasswordReset.textfield_email_helpertext') : t('PasswordReset.textfield_email_helpertext')}
                                    />
                                    <Grid container justifyContent="space-between" style={styles.buttonContainer}>
                                      <Grid item>
                                          <Link to="/" style={{ textDecoration: 'none' }}>
                                              <Button style={{...styles.sendButton, color: theme.palette.primary.dark, marginTop: 20}}
                                                  color="primary">
                                                  <Trans i18nKey="Global.button_cancel"/>
                                                  </Button>
                                          </Link>
                                      </Grid>
                                      <Grid item>
                                          <Button variant="outlined"
                                              style={{...styles.sendButton, color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20}}
                                              onClick={this.resetPassword}
                                              // disabled={requestPending || email.trim().length === 0}
                                              color="primary">
                                              <Trans i18nKey="PasswordReset.button_send_password"/>
                                              </Button>
                                      </Grid>
                                    </Grid>
                                </Grid>)
                            }
                            {success && (
                                <div>
                                    <Grid container justifyContent="center" direction="column" alignItems="center">
                                        <Typography style={{...styles.successText, marginTop: 40, marginBottom: 40, fontSize: 14}}>
                                            <Trans i18nKey="PasswordReset.success_text"/>
                                        </Typography>
                                        <Grid item>
                                            <Button
                                                style={{ color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                                                variant="outlined"
                                                onClick={this.backToLogin}
                                                color="primary">
                                                <Trans i18nKey="PasswordReset.button_to_signin"/>
                                                </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            )}
                        </Grid>
                    </Paper>
                </Grid>
                <Grid container justifyContent="center">
                  <Grid item style={{ marginTop: 20 }}>
                    <Select
                      native
                      variant='standard'
                      disableUnderline
                      labelId={t('ChooseLanguage.button_choose_language')}
                      id="login_language_selectt"
                      value={this.state.language}
                      onChange={this.handleLanguageChange}
                      style={styles.selectLang}
                      sx={{color:"grey", fontSize:12}}
                    >
                      <option value='en'>English</option>
                      <option value='de'>Deutsch</option>
                    </Select>
                  </Grid>
                </Grid>
            </Container>
        )
    }
}

export default PasswordReset
